import axios from "axios";
import { apiVariable } from "./apiVariable";
import { ProfitabilityHistory } from "../components/Fleet/ProfitabilityForecast/forecast";

export interface ProfitabilityTruck {
  id: string;
  unitNumber: string;
  make: string;
  model: string;
  year: number;
  vin: string;
  licensePlate: string;
  isActive: boolean;
  status: string;
}

export async function fetchProfitabilityTrucks(
  token: string | null | undefined,
) {
  const responses = await Promise.all(
    [true, false].map((areActive) =>
      axios.get<ProfitabilityTruck[]>(`${apiVariable}/getAllTrucks`, {
        headers: { Authorization: `Bearer ${token}` },
        params: { areActive },
      }),
    ),
  );
  const trucks = new Map<string, ProfitabilityTruck>();
  responses.forEach((response) =>
    response.data.forEach((truck) => trucks.set(truck.id, truck)),
  );
  return Array.from(trucks.values()).sort((a, b) =>
    a.unitNumber.localeCompare(b.unitNumber, undefined, {
      numeric: true,
      sensitivity: "base",
    }),
  );
}

export async function fetchTruckProfitabilityHistory(
  token: string | null | undefined,
  truckId: string,
) {
  const { data } = await axios.get<ProfitabilityHistory>(
    `${apiVariable}/truck/${truckId}/profitability-history`,
    {
      headers: { Authorization: `Bearer ${token}` },
    },
  );
  return data;
}
